import tinycolor from "tinycolor2";
export const hsl2lab = (hsl) => {
    const xy = polar2Cartesian(hsl.h, hsl.s);
    return { l: hsl.l, a: xy.x, b: xy.y, opacity: hsl.opacity };
};
export const lab2hsl = (lab) => {
    const al = cartesian2Polar(lab.a, lab.b);
    return { h: al.angle, s: al.length, l: lab.l, opacity: lab.opacity };
};
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;
export const polar2Cartesian = (angle, length) => {
    if (isNaN(angle))
        return { x: 0, y: 0 };
    let a = angle * radians;
    return { x: Math.cos(a) * length, y: Math.sin(a) * length };
};
export const cartesian2Polar = (x, y) => {
    return {
        angle: Math.atan2(y, x) * degrees,
        length: Math.sqrt(x * x + y * y),
    };
};
export const toRGB = (tc) => {
    return tinycolor(tc).toRgb();
};
export const clampHue = (hue) => (hue < 0 ? hue + Math.ceil(-hue / 360) * 360 : hue) % 360;
export const clamp = (v) => Math.min(1.0, Math.max(0.0, v));
export const clampAlpha = (alpha) => Math.min(1.0, Math.max(0.0, alpha ?? 1.0));
